module.exports = __webpack_public_path__ + "static/GlitchlessSonyax5f-4307be0cbfe5c2ef7fec96991c04af03.png";